import React from "react";
import { Box } from "@mui/material";
import CustomInput from "../../../../FormFields/CustomInput/CustomInput";

const FlashMessages = ({ formData, setFormData }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <Box sx={{ display: 'flex', gap: 3 }}>
      <Box sx={{ flex: 2 }}>
        <CustomInput
          label="Flash Message Alert"
          name="flash_message"
          value={formData.flash_message}
          onChange={(e) => setFormData({...formData, flash_message: e.target.value})}
          placeholder="Enter flash message"
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <CustomInput
          type="date"
          label="Display Until"
          name="display_until"
          value={formData.display_until}
          onChange={(e) => setFormData({...formData, display_until: e.target.value})}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
    </Box>
  </Box>
);

export default FlashMessages;